import { Divider, Stack, ThemeProvider, Typography } from '@mui/material'
import theme from '../../sharedComponents/src/Theme/theme-v2'
import { useScreenSize } from '../../sharedComponents/src/hooks/useScreenSize'
import { useStoreState } from '../../store/hooks'
import DownloadAppBanner from './DownloadAppBanner'
import MenuCard, { MenuCardProps } from './MenuCard'

export const MainMenu: React.FC = () => {
    const { isMobile } = useScreenSize()
    const userName = useStoreState((state) => state.userData.userData?.user_name)
    const isNewUser = useStoreState((state) => state.profileView.isNewUser)

    const returningMenuCards: Array<MenuCardProps> = [
        {
            title: 'Play now',
            label: 'Challenge players from around the world',
            icon: '/assets/images/main-menu/play-now.svg',
            analyticsEvent: 'playNow',
            redirectUrl: '/?drawer=game',
            size: 'small',
        },
        {
            title: 'Daily puzzle',
            label: 'One puzzle a day keeps blunders away',
            icon: '/assets/images/main-menu/daily-puzzle.svg',
            analyticsEvent: 'dailyPuzzle',
            redirectUrl: '/daily-puzzle',
            size: 'small',
        },
        {
            title: 'Puzzle Quest',
            label: 'Solve chess puzzles and conquer the quest',
            icon: '/assets/images/main-menu/puzzle-quest.svg',
            analyticsEvent: 'puzzleQuest',
            redirectUrl: '/puzzle-quest',
            size: 'small',
        },
        {
            title: 'Puzzle Practice',
            label: 'Sharpen your skills through practice',
            icon: '/assets/images/main-menu/puzzle-practice.svg',
            analyticsEvent: 'puzzles',
            redirectUrl: '/puzzles',
            size: 'small',
        },
        {
            title: 'Play Bots',
            label: 'Play, learn, and improve with bots',
            icon: '/assets/images/main-menu/play-bots.svg',
            analyticsEvent: 'playBots',
            redirectUrl: '/?drawer=bots',
            size: 'small',
        },
    ]

    const newMenuCards: Array<MenuCardProps> = [
        {
            title: 'Puzzle Quest',
            label: 'Solve chess puzzles and conquer the quest',
            icon: '/assets/images/main-menu/puzzle-quest.svg',
            analyticsEvent: 'puzzleQuest',
            redirectUrl: '/puzzle-quest',
            size: 'large',
        },
        {
            title: 'Play now',
            label: 'Challenge players from around the world',
            icon: '/assets/images/main-menu/play-now.svg',
            analyticsEvent: 'playNow',
            redirectUrl: '/?drawer=game',
            size: 'large',
        },
    ]

    return (
        <ThemeProvider theme={theme}>
            <Stack alignItems="center" gap={1.5} sx={{ px: { xs: 1, md: 0 }, py: { xs: 1.5, md: 0 } }}>
                {isNewUser && <img src="/assets/images/logo-with-text.svg" alt="Logo" width={100} height={100} />}
                <Stack alignItems="center" gap={{ xs: 1, md: 0 }} direction={isMobile ? 'row' : 'column'}>
                    <Typography variant={isMobile ? 'h5' : 'h2'} textTransform="uppercase">
                        Welcome
                    </Typography>
                    <Typography variant={isMobile ? 'h5' : 'h2'} textTransform="uppercase" color="primary.main">
                        {userName}
                    </Typography>
                </Stack>
                <Divider flexItem />
                <Stack gap={1.5}>
                    {(isNewUser ? newMenuCards : returningMenuCards).map((item, index) => (
                        <MenuCard
                            key={index}
                            title={item.title}
                            label={item.label}
                            icon={item.icon}
                            analyticsEvent={item.analyticsEvent}
                            redirectUrl={item.redirectUrl}
                            size={item.size}
                        />
                    ))}
                </Stack>
                <DownloadAppBanner />
            </Stack>
        </ThemeProvider>
    )
}
